import { useNavigate } from 'react-router-dom'
import { useAuthContext } from '../../../hooks/useAuthContext'
import { useFetch } from '../../../hooks/useFetch'
import { useEffect, useState } from 'react'
import { Container, Box, Grid, TextField, Typography, Button, Divider } from '@mui/material/'
import DashboardIcon from '@mui/icons-material/Dashboard';
import SelectStudent from '../../../components/SelectStudent'
import { NumericFormat } from 'react-number-format';
import SendIcon from '@mui/icons-material/Send';
import SelectedStudent from '../../../components/SelectedStudent'
import CircularProgress from '@mui/material/CircularProgress';
import CancelIcon from '@mui/icons-material/Cancel';
import { ElectricScooterSharp, ElevatorSharp } from '@mui/icons-material'
import SelectCambridgeExamSession from '../../../components/SelectCambridgeExamSession'
import ViewEntryStatus from '../../../components/cambridge/ViewEntryStatus'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
function CamEntryStatus() {


    const [sessionId, setSessionId] = useState(1)
    const navigate = useNavigate()
    const [processEntry, setProcessEntry] = useState(0)
    const { studentID } = useAuthContext()
    const [studentId, setStudentId] = useState(studentID)

    const month = new Date().getMonth()







    return (
        < Container maxWidth="lg"  >

            <Box mb={5} />
            <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12, lg: 12, xl: 12 }} sx={{ border: 'solid', borderWidth: '3px', borderColor: 'primary.main', borderRadius: 2 }}>

                <Grid item xs={12}>

                    <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        sx={{

                            maxWidth: '95%',
                            marginLeft: 'auto',
                            marginRight: 'auto'
                        }}
                    >
                        <Typography variant="h3" component="h3" color="primary.main" sx={{ textAlign: 'center' }}>
                            Camrbidge Application Status
                        </Typography>



                    </Box>


                </Grid>
                <Grid item xs={12}>

                    <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        sx={{

                            maxWidth: '95%',
                            marginLeft: 'auto',
                            marginRight: 'auto'
                        }}
                    >
                        <Typography variant="body2" component="p" color="primary.main" sx={{ textAlign: 'center' }}>
                            Candidates can view thier Cambridge External Assessment entry application status below
                        </Typography>



                    </Box>


                </Grid>





                <Grid item xs={12}>

                    <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        sx={{

                            maxWidth: '95%',
                            marginLeft: 'auto',
                            marginRight: 'auto'
                        }}
                    >
                        <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                            <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                sx={{

                                    maxWidth: '95%',
                                    marginLeft: 'auto',
                                    marginRight: 'auto'
                                }}
                            >
                                <SelectCambridgeExamSession sessionId={sessionId} setSessionId={setSessionId} camOnly={1} />


                            </Box>

                        </Grid>

                    </Box>

                </Grid>




                <Grid item xs={12} minWidth={0}>

                    <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        sx={{

                            maxWidth: '95%',
                            marginLeft: 'auto',
                            marginRight: 'auto'
                        }}
                    >

                        <ViewEntryStatus setProcessEntry={setProcessEntry} studentId={studentId} sessionId={sessionId} />

                    </Box>
                </Grid>

                <Grid item xs={12}>

                    <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        sx={{

                            maxWidth: '95%',
                            marginLeft: 'auto',
                            marginRight: 'auto'
                        }}
                    >

                        <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                            <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                sx={{

                                    maxWidth: '95%',
                                    marginLeft: 'auto',
                                    marginRight: 'auto'
                                }}
                            >

                                <Button fullWidth variant="contained" onClick={(e) => navigate('/cambridge/apply')}>Process Entry<DashboardIcon /></Button>






                            </Box>

                        </Grid>



                    </Box>

                </Grid>



                <Grid item xs={12}>

                    <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        sx={{

                            maxWidth: '95%',
                            marginLeft: 'auto',
                            marginRight: 'auto'
                        }}
                    >
                        <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                            <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                sx={{

                                    maxWidth: '95%',
                                    marginLeft: 'auto',
                                    marginRight: 'auto'
                                }}
                            >
                                <Button fullWidth variant="contained" onClick={(e) => navigate('/cambridge')}>Dashboard <DashboardIcon /></Button>




                            </Box>
                            <Box mb={5} />
                        </Grid>


                    </Box>
                    <Box mb={5} />
                </Grid>

            </Grid>

            <Box mb={5} />
        </Container>
    )
}

export default CamEntryStatus